import { type ReactElement } from 'react';
import { PRODUCT_CODE } from '../../../enums/productCode.enum';
import { DocumentCheckout } from '../../organisms/Checkout/DocumentCheckout';

export function IDCardCheckout(): ReactElement {
  return <DocumentCheckout productCode={PRODUCT_CODE.RESERVATION_DOCUMENT_ID_CARD} />;
}
